﻿window.cBuilderEmailWidgetCtrl = function cBuilderEmailWidgetCtrl(option) {
    var Me = this;

    // Nom de la classe réellement instanciée (fille comprise).
    // Le bundle minifié supprime le nom des fonctions (constructor.name vide) :
    // on retrouve alors le nom via la variable globale window.xxx qui pointe sur le constructeur.
    var Ctor = this.constructor;
    if (!Ctor.hasOwnProperty("nomClasse")) {
        Ctor.nomClasse = Ctor.name || Object.keys(window).filter(function (k) {
            try { return window[k] === Ctor; } catch (e) { return false; }
        })[0] || "";
    }
    this.classWidget = Ctor.nomClasse;
    this.nomBt = "Zone saisie texte simple";
    this.titleBt = ""
    this.icone = "fafa fafa-textbox";
    this.labelCtrl = "Saisissez une valeur"
    this.typChamp = ""
    this.typeDevExpress = ""
    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='" + Me.nomWidget + "'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            "border": "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        });
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>")
            .appendTo($DivBt);
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>" + Me.nomBt + "</div>")
            .appendTo($DivBt);
        $DivBt.attr("title", Me.titleBt);

        return $DivBt;
    };

    this.mCreateElement = function () {
        var indexCurrent = option.dxBuilderEmailPage.clBuilderFormulaire.mGetNewIndexDevexpress();
        option.element = $("<tr class='widget widgetdevexpress " + this.nomWidget + "' classwidget='" + this.classWidget + "'/>");
        $("<!-- DEBUT FORMTXT -->").appendTo(option.element);
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto'>").appendTo(option.element);
        var jsonDuplik = JSON.parse(
            JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("devexpress"))
        );
        for (var prop in jsonDuplik) jsonDuplik[prop] = "";
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik));
        var $TablePaddingBorder = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td);
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder);
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr);
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget'>").appendTo($Td);
        var $TrTableBt = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='width:35%' class='tdleft'></td>").appendTo($TrTableBt);
        var $Td = $("<td style='width:30%' class='tdcenter'></td>").appendTo($TrTableBt);
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablefomrtxt'>").appendTo($Td);

        var $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='width:100%;' class='txtsaisie eledevexpress' typedevexpress='" + this.typeDevExpress + "' typchamp='" + this.typChamp + "' indexdevexpress='" +
            indexCurrent +
            "' tri='0' obligatoire='0'></td>")
            .appendTo($Tr);
        $Td.attr("label", Me.labelCtrl)

        // =====================================================
        // Les classes filles peuvent ajouter ici leur contenu
        // en surchargeant mCreateElement().
        // =====================================================

        var $Td = $("<td style='width:35%' class='tdright'></td>").appendTo($TrTableBt);

        $("<!-- FIN FORMTXT -->").appendTo(option.element);
    };

    var _onValueChangedDevexpress
    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        _onValueChangedDevexpress = onValueChangedDevexpress
    }


    // =========================================================
    // Méthodes accessibles aux classes filles
    // =========================================================

    this.mGetTdLeft = function () {
        return $(option.element.find(".tdleft")[0]);
    };


    this.mGetTdCenter = function () {
        return $(option.element.find(".tdcenter")[0]);
    };


    this.mGetTdRight = function () {
        return $(option.element.find(".tdright")[0]);
    };


    this.mGetTdSaisie = function () {
        return $(option.element.find(".txtsaisie")[0]);
    };


    this.mGetEleDevExpress = function () {
        return $(option.element.find(".ctrldevexpress")[0]);
    };
    this.mGetEleLibelleCtrl = function () {
        if (option.element.find(".libellectrl").length == 0) {
            return null
        } else {
            return $(option.element.find(".libellectrl")[0]);
        }

    };

    this.mGetTypeCtrlDevexpress = function (value) {
        if (value) this.mGetTdSaisie().attr("typedevexpress", value)
        return this.mGetTdSaisie().attr("typedevexpress")
    }

    this.mGetIndexdevexpress = function () {
        return this.mGetTdSaisie().attr("indexdevexpress")
    }

    this.dx = null
    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty();

        //Me.mGetEleDevExpress().empty()
        Me.dx = Me.mGetEleDevExpress()[Me.mGetTypeCtrlDevexpress()]("instance");
        if (!Me.dx) {
            //on a un control de chez nous
            Me.dx = Me.mGetEleDevExpress().getInstance()
        }

        if (Me.nomWidget != "dxwidgetformcheckbox" && Me.nomWidget != "dxwidgetformbtvalide") {
            // obligatoire
            $("<div style='margin:10px 0 20px 0;'/>")
                .appendTo(contentElement)
                .dxCheckBox({
                    text: "L'utilisateur est obligé de saisir une valeur pour ce champ",
                    hint: "A la validation du formulaire, si le répondant n'a pas rempli ce champ, un message avec la coloration en rouge du champ sera affiché lui demandant de remplir le champ.",
                    value:
                        (typeof Me.mGetTdSaisie().attr("obligatoire") == "undefined"
                            ? "0"
                            : Me.mGetTdSaisie().attr("obligatoire")) == "1",
                    onValueChanged: function (e) {
                        Me.mGetTdSaisie()
                            .attr("obligatoire", e.value ? "1" : "0");
                        option.onValueChanged();
                    }
                })
                .dxCheckBox("instance");
        }

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Titre zone de saisie:</td>").appendTo(contentElement)
        Me.dx.option("label", Me.mGetTdSaisie().attr("label"))
        $("<div/>").appendTo(contentElement).dxCtrlTxtEmoji({
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: Me.mGetTdSaisie().attr("label"),
            placeholder: (Me.nomWidget != "dxwidgetformbtvalide" ? "Titre de la zone de saisie..." : "Texte du bouton"),
            onValueChanged: function (value) {
                Me.mGetTdSaisie().attr("label", value)
                if (Me.mGetEleLibelleCtrl()) Me.mGetEleLibelleCtrl().text(value)
                Me.dx.option("label", value)
                if (Me.nomWidget == "dxwidgetformcheckbox") { Me.dx.option("text", value) }
                else if (Me.nomWidget == "dxwidgetformbtvalide") { Me.dx.option("text", value) }
                else if (Me.nomWidget == "dxwidgetformselect") { Me.mAddCtrlDevExpress(_onValueChangedDevexpress) }
                option.onValueChanged()
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")

        // =====================================================
        // La classe fille peut ajouter ses propres contrôles
        // en surchargeant mAddCtrlSaisie().
        // =====================================================
    };


    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(
            option.parent.mGetBodyWidget().attr("jsoncssdatawidget")
        );

        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("devexpress")) {
            delete jsonCssData[prop];
        }

        option.parent
            .mGetBodyWidget()
            .attr("jsoncssdatawidget", JSON.stringify(jsonCssData));

        option.onValueChanged();
    };


    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(
            option.parent.mGetBodyWidget().attr("jsoncssdatawidget")
        );

        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("devexpress")) {

            if (prop == "width") {

                var widthPercent = 0;

                if (
                    typeof jsonCssData[prop] != "undefined" &&
                    jsonCssData[prop].length > 0
                ) {
                    widthPercent = jsonCssData[prop].replace("%", "");
                }
                else {
                    widthPercent = option.dxBuilderEmailPage
                        .mJsonCssGuideProperty("devexpress", prop)
                        .replace("%", "");
                }

                var rest = 100 - widthPercent;

                Me.mGetTdCenter().attr("width", widthPercent + "%");
                Me.mGetTdCenter().css("width", widthPercent + "%");

                switch (option.parent.mGetTextAlignCss()) {

                    case "left":
                        Me.mGetTdLeft().attr("width", "0");
                        Me.mGetTdLeft().css("width", "0px");

                        Me.mGetTdRight().attr("width", rest + "%");
                        Me.mGetTdRight().css("width", rest + "%");
                        break;

                    case "center":
                        var restDiv2 = rest / 2;

                        Me.mGetTdLeft().attr("width", restDiv2 + "%");
                        Me.mGetTdLeft().css("width", restDiv2 + "%");

                        Me.mGetTdRight().attr("width", restDiv2 + "%");
                        Me.mGetTdRight().css("width", restDiv2 + "%");
                        break;

                    case "right":
                        Me.mGetTdLeft().attr("width", rest + "%");
                        Me.mGetTdLeft().css("width", rest + "%");

                        Me.mGetTdRight().attr("width", "0");
                        Me.mGetTdRight().css("width", "0px");
                        break;
                }
            }
            else {

                if (
                    typeof jsonCssData[prop] != "undefined" &&
                    jsonCssData[prop].length > 0
                ) {
                    Me.mGetTdSaisie().css(prop, jsonCssData[prop]);
                }
                else {
                    Me.mGetTdSaisie().css(
                        prop,
                        option.dxBuilderEmailPage.mJsonCssGuideProperty(
                            "devexpress",
                            prop
                        )
                    );
                }
            }
        }
    };
};